import { render, staticRenderFns } from "./RecordingPlayer.vue?vue&type=template&id=83b729b0&scoped=true&"
import script from "./RecordingPlayer.vue?vue&type=script&lang=js&"
export * from "./RecordingPlayer.vue?vue&type=script&lang=js&"
import style0 from "./RecordingPlayer.vue?vue&type=style&index=0&id=83b729b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b729b0",
  null
  
)

export default component.exports